import { Box, Stack } from '@mui/material';
import ReactMarkdown from 'react-markdown';
import ReadAloudButton from './ReadAloudButton';

/**
 * Renders Training markdown. By default includes a Read aloud control for
 * learner-facing content.
 */
export default function TrainingMarkdown({
  children,
  className = '',
  readAloud = true,
  readAloudLabel = 'Read aloud',
}) {
  if (!children) return null;

  const body = (
    <div className={className || undefined}>
      <ReactMarkdown
        components={{
          p: ({ children: c }) => <p className="mb-2 last:mb-0">{c}</p>,
          ul: ({ children: c }) => <ul className="list-disc pl-5 mb-2">{c}</ul>,
          ol: ({ children: c }) => <ol className="list-decimal pl-5 mb-2">{c}</ol>,
          li: ({ children: c }) => <li className="mb-1">{c}</li>,
          strong: ({ children: c }) => <strong className="font-semibold">{c}</strong>,
          a: ({ href, children: c }) => (
            <a href={href} className="text-blue-600 underline" target="_blank" rel="noreferrer">
              {c}
            </a>
          ),
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  );

  if (!readAloud) return body;

  return (
    <Box sx={{ position: 'relative' }}>
      <Stack direction="row" justifyContent="flex-end" sx={{ mb: 0.25, minHeight: 28 }}>
        <ReadAloudButton text={String(children)} label={readAloudLabel} />
      </Stack>
      {body}
    </Box>
  );
}
